import styled from 'styled-components'
import { Grid } from '@material-ui/core'

export const Wrapper = styled(Grid)`
	padding: 16px 24px;
	background-color: ${props => props.theme.background.light};
	border: 1px solid ${props => props.theme.grey.third};
	border-radius: 5px;
`
